import React, { useState } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Home from './Components/HomePage';
import Auth from './Components/Auth';
import Dashboard from './Components/Dashboard';
import Assessments from './Components/Assessments';
import Patients from './Components/Patients';
import PatientDetail from './Components/PatientDetail';
import AdminLogin from './Components/Adminlogin'
import AdminDashboard from './Components/Admindashboard'
import DoctorsList from './Components/Doctorslist'
import AgentsList from './Components/Agentslist';
import Example from './Components/CrfForm'
import AdminSettings from './Components/AdminSettings';
import SuperAdmin from './Components/SuperAdmin';
import ClientAdmin from './Components/ClientAdmin';
import Navbar from './Components/Navbar';
import AdminNavbar from './Components/AdminNavbar';
import './App.css';

const App = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleCollapseAdmin = () => {
    setCollapsed(!collapsed);
  };

  const navbarComponent = localStorage.accessToken ? (localStorage.user === "admin" ? <AdminNavbar onToggleCollapseAdmin={handleToggleCollapseAdmin} /> : <Navbar onToggleCollapse={handleToggleCollapse} />) : null;

  const navWidthClass = !collapsed ? "navWidth" : "navWidth2";

  let routes = (
    <Switch>
      <Route path="/" component={Auth} exact />
      <Route path="/admin" component={AdminLogin} />
      <Route path="/*" component={() => <Redirect to="/" />} exact />
    </Switch>
  );

  if (localStorage.accessToken) {
    routes = (
      <div className='appContainer'>
        <div className={navWidthClass}>
          {navbarComponent}
        </div>
        <div className='containerWidth'>
          <Switch>
            <Route path="/home" component={Dashboard} />
            <Route path="/assessments" component={Assessments} />
            <Route path="/patients" component={Patients} />
            <Route path="/adminsettings" component={AdminSettings} />
            <Route path="/patient/:doctorId/:patientId" component={PatientDetail} />
            <Route path="/admindashboard" component={AdminDashboard} />
            <Route path="/doctorslist" component={DoctorsList} />
            <Route path="/agentslist" component={AgentsList} />
            <Route path="/superadmin" component={SuperAdmin} />
            <Route path="/clientadmin/:clientId/:clientName" component={ClientAdmin} />
            <Route path="/crf/:doctorId/:patientId" component={Example} />
            <Route path="/*" component={() => <Redirect to="/home" />} exact />
          </Switch>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div>{routes}</div>
    </div>
  );
};

export default withRouter(App);
